export default [
  {
    path: '/',
    name: 'home',
    component: async () => await import('@/views/uwin/HomeView.vue'),
  },
  {
    path: '/create-campaign',
    name: 'create-campaign',
    component: () => import('@/views/uwin/CreateCampaign.vue'),
  },
  {
    meta: { title: 'menu.editCampaign' },
    path: '/campaigns/edit/:id',
    name: 'edit-campaign',
    component: () => import('@/views/uwin/EditCampaign.vue'),
  },
   {
    meta: { title: 'menu.editInvoice' },
    path: '/invoice/edit/:id',
    name: 'edit-invoice',
    component: () => import('@/views/uwin/EditInvoice.vue'),
  },
  {
    meta: { title: 'menu.addSurvey' },
    path: '/add-survey',
    name: 'add-survey',
    component: () => import('@/views/uwin/CreateSurvey.vue'),
  },
  {
    meta: { title: 'menu.editSurvey' },
    path: '/survey/edit/:id',
    name: 'edit-survey',
    component: () => import('@/views/uwin/EditSurvey.vue'),
  },
  {
    meta: { title: 'menu.surveyAnalytics' },
    path: '/survey-analytics',
    name: 'survey-analytics',
    component: () => import('@/views/uwin/SurveyAnalyticsView.vue'),
  },
  {
    meta: { title: 'menu.addProduct' },
    path: '/add-product',
    name: 'add-product',
    component: () => import('@/views/uwin/CreateProduct.vue'),
  },
  {
    meta: { title: 'menu.addGrade' },
    path: '/add-grade',
    name: 'add-grade',
    component: () => import('@/views/uwin/CreateGrade.vue'),
  },
  {
    meta: { title: 'menu.medals' },
    path: '/medals',
    name: 'medals',
    component: () => import('@/views/uwin/MedalView.vue'),
  },
  {
    meta: { title: 'menu.addMedal' },
    path: '/add-medal',
    name: 'add-medal',
    component: () => import('@/views/uwin/CreateMedal.vue'),
  },
  {
    meta: { title: 'menu.ticketDetail' },
    path: '/tickets/edit/:ticket_id',
    name: 'edit-ticket-entities',
    component: () => import('@/views/uwin/TicketChat.vue'),
  },
  {
    meta: { title: 'menu.ticketDetail' },
    path: '/support/ticket/:ticket_id/reply',
    name: 'ticket-reply',
    component: () => import('@/views/uwin/TicketChat.vue'),
  },
  {
    meta: { title: 'menu.addContent' },
    path: '/add-content',
    name: 'add-content',
    component: () => import('@/views/uwin/CreateContentSection.vue'),
  },
  {
    meta: { title: 'menu.addContactInfo' },
    path: '/add-contact-info',
    name: 'add-contact-info',
    component: () => import('@/views/uwin/CreateContactInfo.vue'),
  },
  {
    meta: { title: 'menu.addCategory' },
    path: '/add-category',
    name: 'add-category',
    component: () => import('@/views/uwin/CreateCategory.vue'),
  },
  {
    meta: { title: 'menu.addBanner' },
    path: '/add-banner',
    name: 'add-banner',
    component: () => import('@/views/uwin/CreateBanner.vue'),
  },
  {
    meta: { title: 'menu.editBanner' },
    path: '/banner/edit/:id',
    name: 'edit-banner',
    component: () => import('@/views/uwin/EditBanner.vue'),
  },
  {
    meta: { title: 'menu.editBanner' },
    path: '/banners/edit/:id',
    name: 'edit-banner-entities',
    component: () => import('@/views/uwin/EditBanner.vue'),
  },
  {
    meta: { title: 'menu.editCategory' },
    path: '/category/edit/:id',
    name: 'edit-category',
    component: () => import('@/views/uwin/EditCategory.vue'),
  },
  {
    meta: { title: 'menu.editCategory' },
    path: '/categories/edit/:id',
    name: 'edit-category-entities',
    component: () => import('@/views/uwin/EditCategory.vue'),
  },
  {
    meta: { title: 'menu.editGrade' },
    path: '/grade/edit/:id',
    name: 'edit-grade',
    component: () => import('@/views/uwin/EditGrade.vue'),
  },
  {
    meta: { title: 'menu.editGrade' },
    path: '/grades/edit/:id',
    name: 'edit-grade-entities',
    component: () => import('@/views/uwin/EditGrade.vue'),
  },
  {
    meta: { title: 'menu.editMedal' },
    path: '/medal/edit/:id',
    name: 'edit-medal',
    component: () => import('@/views/uwin/EditMedal.vue'),
  },
  {
    meta: { title: 'menu.editMedal' },
    path: '/medals/edit/:id',
    name: 'edit-medal-entities',
    component: () => import('@/views/uwin/EditMedal.vue'),
  },
  {
    meta: { title: 'menu.editContent' },
    path: '/content/edit/:id',
    name: 'edit-content',
    component: () => import('@/views/uwin/EditContentSection.vue'),
  },
  {
    meta: { title: 'menu.editContent' },
    path: '/contents/edit/:id',
    name: 'edit-content-entities',
    component: () => import('@/views/uwin/EditContentSection.vue'),
  },
  {
    meta: { title: 'menu.editContactInfo' },
    path: '/contact-info/edit/:id',
    name: 'edit-contact-info',
    component: () => import('@/views/uwin/EditContactInfo.vue'),
  },
  {
    meta: { title: 'menu.editContactInfo' },
    path: '/contact-infos/edit/:id',
    name: 'edit-contact-info-entities',
    component: () => import('@/views/uwin/EditContactInfo.vue'),
  },
  {
    meta: { title: 'menu.addNotification' },
    path: '/add-notification',
    name: 'add-notification',
    component: () => import('@/views/uwin/CreateNotification.vue'),
  },
  {
    meta: { title: 'menu.addStore' },
    path: '/add-store',
    name: 'add-store',
    component: () => import('@/views/uwin/CreateStore.vue'),
  },
  {
    meta: { title: 'menu.homeShortcuts' },
    path: '/home-shortcuts',
    name: 'home-shortcuts',
    component: () => import('@/views/uwin/HomeShortcuts.vue'),
  },
  {
    meta: { title: 'menu.editProduct' },
    path: '/products/edit/:id',
    name: 'edit-product',
    component: () => import('@/views/uwin/EditProduct.vue'),
  },
  {
    meta: { title: 'menu.addMission' },
    path: '/add-mission',
    name: 'add-mission',
    component: () => import('@/views/uwin/AddMission.vue'),
  },
  {
    meta: { title: 'menu.editMission' },
    path: '/mission/edit/:id',
    name: 'edit-mission',
    component: () => import('@/views/uwin/EditMission.vue'),
  },
  {
    meta: { title: 'menu.gifts' },
    path: '/gifts',
    name: 'gifts',
    component: () => import('@/views/uwin/GiftProductsView.vue'),
  },
  {
    meta: { title: 'menu.addGift' },
    path: '/add-gift',
    name: 'add-gift',
    component: () => import('@/views/uwin/GiftForm.vue'),
  },
  {
    meta: { title: 'menu.addGift' },
    path: '/gifts/edit/:id',
    name: 'edit-gift',
    component: () => import('@/views/uwin/GiftForm.vue'),
  },
  {
    meta: { title: 'menu.giftCategories' },
    path: '/gift-categories',
    name: 'gift-categories',
    component: () => import('@/views/uwin/GiftCategoriesView.vue'),
  },
  {
    meta: { title: 'menu.giftCategories' },
    path: '/add-gift-category',
    name: 'add-gift-category',
    component: () => import('@/views/uwin/GiftCategoryForm.vue'),
  },
  {
    meta: { title: 'menu.giftCategories' },
    path: '/gift-categories/edit/:id',
    name: 'edit-gift-category',
    component: () => import('@/views/uwin/GiftCategoryForm.vue'),
  },
  {
    meta: { title: 'menu.voucherStorage' },
    path: '/vouchers/storage',
    name: 'voucher-storage',
    component: () => import('@/views/uwin/VouchersView.vue'),
  },
  {
    meta: { title: 'menu.vouchersUsed' },
    path: '/vouchers/used',
    name: 'vouchers-used',
    component: () => import('@/views/uwin/VouchersView.vue'),
  },
  {
    meta: { title: 'menu.uploadVoucher' },
    path: '/vouchers/upload',
    name: 'vouchers-upload',
    component: () => import('@/views/uwin/UploadVoucherView.vue'),
  },
]
